<h2 mat-dialog-title>Are you sure you want to proceed?</h2>
<mat-dialog-content>
    {{data}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="false">No</button>
  <button class="mat-btn-theme" mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</mat-dialog-actions>